module.exports = "pegasus/assets/blocks/column-11-theme3.png";